import { render, staticRenderFns } from "./QuickButtons.vue?vue&type=template&id=0aa0ae18&scoped=true&"
import script from "./QuickButtons.vue?vue&type=script&lang=js&"
export * from "./QuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa0ae18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa0ae18')) {
      api.createRecord('0aa0ae18', component.options)
    } else {
      api.reload('0aa0ae18', component.options)
    }
    module.hot.accept("./QuickButtons.vue?vue&type=template&id=0aa0ae18&scoped=true&", function () {
      api.rerender('0aa0ae18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/reservations/QuickButtons.vue"
export default component.exports